import * as React from 'react';

const Dots24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M6 4.5a1.5 1.5 0 1 0-2.999-.001A1.5 1.5 0 0 0 6 4.5m0 15a1.5 1.5 0 1 0-2.999-.001A1.5 1.5 0 0 0 6 19.5m-1.469-9a1.5 1.5 0 1 1 .002 2.999A1.5 1.5 0 0 1 4.53 10.5Zm8.969-6a1.5 1.5 0 1 0-2.999-.001A1.5 1.5 0 0 0 13.5 4.5M12 18a1.5 1.5 0 1 1 .001 2.999A1.5 1.5 0 0 1 12 18m1.5-6a1.5 1.5 0 1 0-2.999-.001A1.5 1.5 0 0 0 13.5 12m6-9a1.5 1.5 0 1 1 .001 2.999A1.5 1.5 0 0 1 19.5 3M21 19.5a1.5 1.5 0 1 0-2.999-.001A1.5 1.5 0 0 0 21 19.5m-1.5-9a1.5 1.5 0 1 1 .001 2.999A1.5 1.5 0 0 1 19.5 10.5"
  }
));
Dots24.Size = 24;
Dots24.Title = "Dots";

export { Dots24 as default };
